<template>
    <div class="space-y-6">
        <UiInput
            type="date"
            id="departure_date"
            name="departure_date"
            label="What is your desired departure date?"
            v-model:inputValue="form.departure_date"
            :errors="errors"
            :options="{ required: true }"
        />

        <FormYesNo
            label="Is your departure date flexible?"
            name="departure_date_flexible"
            v-model="form.departure_date_flexible"
            :errors="errors"
            required
        />

        <UiInput
            v-if="form.departure_date_flexible"
            id="departure_flexibility"
            name="departure_flexibility"
            label="How flexible is your departure date?"
            placeholder="e.g. plus or minus 3 days"
            v-model:inputValue="form.departure_flexibility"
            :errors="errors"
            :options="{ required: true }"
        />

        <template v-if="isRoundTrip">
            <UiInput
                type="date"
                id="return_date"
                name="return_date"
                label="What is your desired return date?"
                v-model:inputValue="form.return_date"
                :errors="errors"
                :options="{ required: true }"
            />

            <FormYesNo
                label="Is your return date flexible?"
                name="return_date_flexible"
                v-model="form.return_date_flexible"
                :errors="errors"
                required
            />

            <UiInput
                v-if="form.return_date_flexible"
                id="return_flexibility"
                name="return_flexibility"
                label="How flexible is your return date?"
                placeholder="e.g. plus or minus 3 days"
                v-model:inputValue="form.return_flexibility"
                :errors="errors"
                :options="{ required: true }"
            />
        </template>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <UiInput
                type="number"
                id="min_trip_length_days"
                name="min_trip_length_days"
                label="Minimum length of trip (total days)"
                v-model:inputValue="form.min_trip_length_days"
                :errors="errors"
                :options="{ optional: true }"
            />
            <UiInput
                type="number"
                id="max_trip_length_days"
                name="max_trip_length_days"
                label="Maximum length of trip (total days)"
                v-model:inputValue="form.max_trip_length_days"
                :errors="errors"
                :options="{ optional: true }"
            />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import UiInput from '@/components/ui/inputs/ui-input.vue';
import FormYesNo from '@/components/award-bookings/request-form/form-yes-no.vue';

const props = defineProps({
    form: { type: Object, required: true },
    errors: { type: Object, default: null },
});

const isRoundTrip = computed(() => props.form.trip_type === 'round_trip');
</script>
